
import { mapState } from 'vuex'
import { listPageBannerData } from '@/utils/constants'
import tailwindConfig from '@/tailwind.config.js'

export default {
  props: {
    brandId: {
      type: Number,
      default: undefined,
    },
    categoryId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      tablet: parseInt(tailwindConfig.theme.screens.tablet, 10),
      desktopMd: parseInt(tailwindConfig.theme.screens['desktop-md'], 10),
    }
  },
  computed: {
    ...mapState(['app']),
    showBanner() {
      if (!this.app?.listPageBanners?.enabled) {
        return false
      }
      return listPageBannerData.categories.includes(this.categoryId) || listPageBannerData.brands.includes(this.brandId)
    },
    bannersFolder() {
      return `/png/banners/${this.$i18n?.locale}/acuvue`
    },
  },
}
